import get from 'lodash/get'
import '../vee-validate'
import RTLPlugin from './RTLPlugin'
import '../util/globalComponentsRequire'
import globalDirectives from './globalDirectives'
import { Button, Form, FormItem, Input, Switch, Tooltip } from 'element-ui'
import '../assets/scss/main.scss'
import { CollapseTransition, FadeTransition } from 'vue2-transitions'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AppNotifyService from '@/util/AppNotifyService.js'

export default {
    install (Vue) {
        Vue.use(Form)
        Vue.use(Input)
        Vue.use(Button)
        Vue.use(FormItem)
        Vue.use(Tooltip)
        Vue.use(Switch)
        Vue.use(RTLPlugin)
        Vue.use(AppNotifyService)
        Vue.use(globalDirectives)
        Vue.component(FadeTransition.name, FadeTransition)
        Vue.component(CollapseTransition.name, CollapseTransition)
        Vue.component('ValidationObserver', ValidationObserver)
        Vue.component('ValidationProvider', ValidationProvider)
        Vue.mixin({
            methods: {
                get,
            },
        })
    },
}
